import React, { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Checkbox
} from "@mui/material";
import styles from "../../../styles.module.css";
import pickupService from "../../../services/pickup.Service";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  SearchInput,
  StyledTableCell,
  StyledTableRow
} from "../../reusableComponent/Reusables";
import HeaderSection from "../../reusableComponent/HeaderSection";
import sales_order from "../../../services/sales_order";
import PendingSalesOrderPrint from "./PendingSalesOrderPrint";
import { useReactToPrint } from "react-to-print";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const Pending_Sales_Order = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);

  const defaultRowsPerPage = useSelector(state => state.sales_order?.rows_per_page || 15);
    const [total_count,setTotalCount]=useState(null)
    useEffect(() => {
      setTotalCount(rows[0]?.totalCount);
    }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);
  const [sortBy, setSortBy] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [successMessage, setSuccessMessage] = useState(null);
  const totalCount = useSelector(state => state.pickup_entry?.total_count || 0);
  
  const [prodTypeFilter, setProdTypeFilter] = useState("all");
  const [filteredCount, setFilteredCount] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [initialized, setInitialized] = useState(false);
  const printRef = useRef();
  const [printData, setPrintData] = useState([]);

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };

      const response = await sales_order.getpendingSalesorder(params);
      let dataArray = response;
      if (!Array.isArray(response) && response.data) {
        dataArray = response.data;
      } else if (!Array.isArray(response)) {
        dataArray = [response];
      }

      const processedData = dataArray.map(row => ({ ...row }));
      setRows(processedData);
      setInitialized(false);
    } catch (error) {
      console.error("Error in fetchData:", error);
      setSuccessMessage("Error fetching data");
    }
  };


  const filteredRows = useMemo(() => {
    if (!Array.isArray(rows)) return [];
    return prodTypeFilter === "all" ? rows : rows.filter(row => row.prod_type === prodTypeFilter);
  }, [rows, prodTypeFilter]);


  const sortedRows = useMemo(() => {
    return [...filteredRows].sort((a, b) => {
      const dateA = a.po_date ? new Date(a.po_date) : new Date();
      const dateB = b.po_date ? new Date(b.po_date) : new Date();
      return dateB - dateA;
    });
  }, [filteredRows]);



  useEffect(() => {
    if (!initialized && sortedRows.length > 0) {
      const allRowIds = sortedRows.map(row => row.sales_order_id || row.po_no + row.prod_id);
      setSelectedRows([]); // Clear selected rows
      setInitialized(true); // Set initialized to true
    }
  }, [sortedRows, initialized]); // Trigger when sortedRows or initialized changes

  const handleRowCheckbox = (id) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.includes(id)) {
        return prevSelectedRows.filter(item => item !== id);
      } else {
        return [...prevSelectedRows, id];
      }
    });
  };
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

  const handleChangePage = (event, newPage) => {
    setController(prev => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);
    setController(prev => ({ ...prev, page: 0 }));
  };

  const handleProdTypeFilterChange = (event) => {
    setProdTypeFilter(event.target.value);
    setController(prev => ({ ...prev, page: 0 }));
  };

  const HandleSort = (field) => {
    const newSortBy = sortBy === field ? null : field;
    setSortBy(newSortBy);

    if (newSortBy) {
      rows.sort((a, b) => {
        if (a[newSortBy] < b[newSortBy]) return -1;
        if (a[newSortBy] > b[newSortBy]) return 1;
        return 0;
      });
    } else {
      fetchData();
    }
  };
  const printFunction = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Pending Sales Order",
    removeAfterPrint: true
  });

  useEffect(() => {
    setFilteredCount(filteredRows.length);
  }, [filteredRows]);

  useEffect(() => {
    const maxPage = Math.max(0, Math.ceil(filteredCount / controller.rowsPerPage) - 1);
    if (controller.page > maxPage && filteredCount > 0) {
      setController(prev => ({ ...prev, page: maxPage }));
    }
  }, [filteredCount, controller.rowsPerPage, controller.page]);

  useEffect(() => {
    fetchData();
  }, [controller, searchKey]);

  const handlePrint = () => {
    const selectedData = sortedRows.filter(row => {
      const rowId = row.sales_order_id || row.po_no + row.prod_id;
      return selectedRows.includes(rowId);
    });
    setPrintData(selectedData);
    setTimeout(() => {
      printFunction();
    }, 100);
  };



  return (
    <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: "Pending Sales Order" }]} />

        <HeaderSection
          title="Pending Sales order"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={["customer_name", "po_no", "po_date", "prod_code", "cylinder_code", "plan_qty", "prod_type"]}
          labels={["Customer Name", "PO NO", "PO Date", "Prod Code", "Cylinder Code", "Plan Qty", "Prod Type"]}
          filename="Pending Sales order"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          PrintIcon_print={{ onClick: handlePrint }}
        />

        <Box item xs={12} md={6}>
          <FormControl sx={{ minWidth: 200, float: 'right' }}>
            <InputLabel id="prod-type-filter-label">Product Type</InputLabel>
            <Select
              labelId="prod-type-filter-label"
              id="prod-type-filter"
              value={prodTypeFilter}
              label="Product Type"
              onChange={handleProdTypeFilterChange}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="Mfg Item">Manufacturing Item</MenuItem>
              <MenuItem value="Trading Item">Trading Item</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Paper sx={{ width: '100%', }}>
          <TableContainer component={Paper} className={styles.list_tbl_container}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell />
                  <StyledTableCell align="center" className={styles.table_head} onClick={() => HandleSort("customer_name")}>
                    Customer Name <span className={styles.sort_icon}>{sortBy === "customer_name" ? "▲" : "▼"}</span>
                  </StyledTableCell>
                  <StyledTableCell align="center" className={styles.table_head} onClick={() => HandleSort("po_no")}>
                    PO NO <span className={styles.sort_icon}>{sortBy === "po_no" ? "▲" : "▼"}</span>
                  </StyledTableCell>
                  <StyledTableCell align="center" className={styles.table_head} onClick={() => HandleSort("po_date")}>
                    PO Date <span className={styles.sort_icon}>{sortBy === "po_date" ? "▲" : "▼"}</span>
                  </StyledTableCell>
                  <StyledTableCell align="center" className={styles.table_head}>Prod ID</StyledTableCell>
                  <StyledTableCell align="center" className={styles.table_head}>Prod Code</StyledTableCell>
                  <StyledTableCell align="center" className={styles.table_head}>Cylinder Code</StyledTableCell>
                  <StyledTableCell align="center" className={styles.table_head}>Plan Qty</StyledTableCell>
                  <StyledTableCell align="center" className={styles.table_head}>Prod Type</StyledTableCell>
                </StyledTableRow>
              </TableHead>

              <TableBody sx={{ backgroundColor: '#fff' }}>
                {sortedRows.length > 0 ? (
                  sortedRows.slice(
                    controller.page * controller.rowsPerPage,
                    controller.page * controller.rowsPerPage + controller.rowsPerPage
                  ).map((row) => {
                    const rowId = row.sales_order_id || row.po_no + row.prod_id;
                    const isChecked = selectedRows.includes(rowId); // Check if row is selected

                    return (
                      <StyledTableRow key={rowId}>

                        <StyledTableCell padding="checkbox">
                          <Checkbox
                            checked={isChecked}
                            onChange={() => handleRowCheckbox(rowId)}
                          />


                        </StyledTableCell>
                        <StyledTableCell align="center" className={styles.list_table_body}>{row.customer_name}</StyledTableCell>
                        <StyledTableCell align="center" className={styles.list_table_body}>{row.po_no}</StyledTableCell>
                        <StyledTableCell align="center" className={styles.list_table_body}>{row.po_date ? new Date(row.po_date).toLocaleDateString() : '-'}</StyledTableCell>
                        <StyledTableCell align="center" className={styles.list_table_body}>{row.prod_id || "-"}</StyledTableCell>
                        <StyledTableCell align="center" className={styles.list_table_body}>{row.prod_code || "-"}</StyledTableCell>
                        <StyledTableCell align="center" className={styles.list_table_body}>{row.cylinder_code || "-"}</StyledTableCell>
                        <StyledTableCell align="center" className={styles.list_table_body}>{row.plan_qty || "-"}</StyledTableCell>
                        <StyledTableCell align="center" className={styles.list_table_body}>{row.prod_type || "-"}</StyledTableCell>
                      </StyledTableRow>
                    );
                  })
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={9} align="center" className={styles.list_table_body}>
                      No records found for the selected filter
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
            component="div"
            count={effectiveTotalCount}
            rowsPerPage={controller.rowsPerPage}
            page={Math.min(controller.page, Math.max(0, Math.ceil(effectiveTotalCount / controller.rowsPerPage) - 1))}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
      <div style={{ display: "none" }}>
        <PendingSalesOrderPrint ref={printRef} data={printData} />
      </div>
    </Box>
  );
};

export default Pending_Sales_Order;
